"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceStyler = void 0;
const ModelCommon_1 = require("./ModelCommon");
const placeTypeName = 'PlaceStyler';
class PlaceStyler extends ModelCommon_1.ModelCommon {
    // primaryS3Image: any;
    constructor(ob) {
        super(placeTypeName, ob);
        this.name = ob.name;
        this.id = ob.id;
        this.description = ob.description;
        this.color = ob.color;
        this.icon = ob.icon;
        // this.primaryS3Image = ob.primaryS3Image;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            color: { type: 'String', editable: true, label: 'color', name: 'color', description: 'description' },
            // icon: { type: 'String', editable: true, label: 'icon', name: 'icon', description: 'description' },
        };
    }
}
exports.PlaceStyler = PlaceStyler;
